module.exports = __webpack_public_path__ + "img/ce6d27a9f0ca089ce0043a36ebe4e8cd.png";